import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import { TBillingQuoteValidationResult } from './types';

export function useBillingQuoteValidation(quoteId: string | null) {
  const { data, error, isLoading, mutate } = useSWR<TBillingQuoteValidationResult>(
    quoteId ? `commenda-billing/quotes/${quoteId}/validation` : null,
    SWRFetcher({ method: 'GET' })
  );

  return { validation: data ?? null, error, isLoading, mutate };
}
